angular.module('common.directives').directive('edgeRecordingList', function () {
  return {
    scope: {
      edge: '='
    },
    templateUrl: './templates/edgeRecordingsList.view.html?t=' + webpackHash,
    link: function ($scope, $element) {},
    controller: 'edgeRecordingsListController'
  }
})
